<template>
  <div>
    <div v-if="body != null" class="lp_page"></div>
    <NotFound v-else-if="isNotFound" />
  </div>
</template>

<script>
import { GET_CLIENT_LP_PAGE } from '@/store/lp/actions'
import { API_URL } from '@/common/config'
import NotFound from '@/components/404.vue'

export default {
  name: 'ClientLp',
  components: {
    NotFound
  },
  data () {
    return {
      lpDir: this.$route.params.lpDir || null,
      lpCode: this.$route.params.lpCode || null,
      code: this.$route.params.code || null,
      body: null,
      isJs: false,
      isNotFound: false,
      params: {}
    }
  },
  methods: {
    getLp () {
      this.getQueryStrings()

      this.$store.dispatch(GET_CLIENT_LP_PAGE, {
        lpDir: this.lpDir,
        lpCode: this.lpCode,
        code: this.code,
        params: {
          params: this.params
        }
      })
        .then((data) => {
          this.body = data.body
          if (Object.keys(data.params).length) {
            // eslint-disable-next-line
            $.params = JSON.stringify(data.params)
          }
          // eslint-disable-next-line
          $('title').html(data.title + ' - ' + data.page_title)
        })
        .catch((error) => {
          if (error.errorStatus === 404) {
            this.isNotFound = true
          }
        })
    },
    getQueryStrings () {
      try {
        var search = document.location.search.substring(1)
        if (!search && document.location.hash && document.location.hash.split('?').length > 1) {
          search = document.location.hash.split('?')[1]
        }
        const params = JSON.parse('{"' + decodeURI(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"') + '"}')

        this.params = params
      } catch (e) {
      }
    },
    runScript () {
      // ユーザ登録用のJSを読み込む
      const div = this.$el.querySelector('div.lp_page')
      if (div) {
        const alternativeNode = document.createElement('script')
        alternativeNode.src = '/assets/js/user_reg.js'
        div.appendChild(alternativeNode)
        const alternativeNode2 = document.createElement('script')
        alternativeNode2.src = '/assets/js/user_reg_complete.js'
        div.appendChild(alternativeNode2)
      }
    },
    setBody () {
      // 取得したHTMLをbodyにセット
      const div = this.$el.querySelector('div.lp_page')
      if (div) {
        const range = document.createRange()
        range.selectNode(div)
        div.appendChild(range.createContextualFragment(this.body))
      }
    }
  },
  created () {
    this.getLp()
  },
  mounted () {
    // eslint-disable-next-line
    $('title').html('')
    // eslint-disable-next-line
    $.api_url = API_URL
    // eslint-disable-next-line
    $.lp_cd = this.lpCode
    // eslint-disable-next-line
    $.lp_dir = this.lpDir
  },
  updated () {
    this.runScript()
    this.setBody()
  }
}
</script>
